import React, { useState } from 'react';
import Header from '../layout/Header';
import { Outlet } from 'react-router-dom';
import ModalInfo from '../modals/ModalInfo';
import UserDetail from '../features/User/UserDetails';

const InnerLayout = () => {
  const [toggle, setToggle] = useState(true);

  return (
    <>
      <Header setToggle={setToggle} toggle={toggle} />
      <div id="page_container" className={toggle ? 'toggled' : ''}>
        <div className="main_container">
          <Outlet />
        </div>
      </div>

      <ModalInfo />
      <UserDetail />
    </>
  );
};

export default InnerLayout;
